// 
var PetStoryRedirector = xClass("PetStoryRedirector", BaseRedirector)
PetStoryRedirector.prototype.getName = function () {
    var self = this
    return "petstory"
}
PetStoryRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
PetStoryRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    console.log("[PetStory] PetStoryRedirector um.settings",um.settings)
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }

    //  检查是否为点自己的链接
    let uid = um.uid;
    let inviteCode = param["inviteCode"] == null? null: +param["inviteCode"];
    let isMythis = inviteCode === uid || false;
    if (isMythis) {
        Toast.make(getText("error.tip.762576"));
        return true;
    }
    

    console.log("[PetStory] PetStoryRedirector param",param)

    if (um.uid && param.inviteCode && param.shareId) {
        let http = PetStoryShareClickHttp.new();
        http.addEventListener(Events.kComplete, (evt) => {
            cc.log("[PetStory] shareClick evt ",evt)
            Toast.make(getText("领养成功！快去看看你的萌宠吧~"));
        })
        http.addEventListener(Events.kError, (evt = {}) => {
            // 加入失败
            // Toast.make(quickGetErrorText(evt.data, "帮助链接已经失效！"));
            if (evt.data){
                Toast.make(getText("error.tip."+evt.data.toString()));
            }
        })
        http.addEventListener(Events.kCancel, (evt = {}) => {
            // 加入失败
            if (evt.data){
                Toast.make(getText("error.tip."+evt.data.toString()));
            }
        })
        http.load(param.inviteCode, param.shareId);
    }
    return true
}
module.exports = PetStoryRedirector
